/**
 * Convert a font size to a dynamic font size.
 * Fonts that participate in Dynamic Type should use
 * dynamic font sizes.
 * @param size - The initial font size including the unit (i.e. px or pt)
 * @param unit (optional) - The unit to convert to. Use this if you want to
 * convert to a unit other than $baselineUnit.
 */
/**
 * Convert a font size to a dynamic font size but impose
 * a maximum font size.
 * @param size - The initial font size including the unit (i.e. px or pt)
 * @param maxScale - The maximum scale of the font (i.e. 2.5 for a maximum 250% scale).
 * @param unit (optional) - The unit to convert the initial font size to. Use this if you want to
 * convert to a unit other than $baselineUnit.
 */
/**
 * Convert a font size to a dynamic font size but impose
 * a minimum font size.
 * @param size - The initial font size including the unit (i.e. px or pt)
 * @param minScale - The minimum scale of the font (i.e. 0.8 for a minimum 80% scale).
 * @param unit (optional) - The unit to convert the initial font size to. Use this if you want to
 * convert to a unit other than $baselineUnit.
 */
/**
 * Convert a font size to a dynamic font size but impose
 * maximum and minimum font sizes.
 * @param size - The initial font size including the unit (i.e. px or pt)
 * @param minScale - The minimum scale of the font (i.e. 0.8 for a minimum 80% scale).
 * @param maxScale - The maximum scale of the font (i.e. 2.5 for a maximum 250% scale).
 * @param unit (optional) - The unit to convert the initial font size to. Use this if you want to
 * convert to a unit other than $baselineUnit.
 */
/**
 * A heuristic that applies CSS to tablet
 * viewports.
 *
 * Usage:
 * @include tablet-viewport() {
 *   :host {
 *     background-color: green;
 *   }
 * }
 */
/**
 * A heuristic that applies CSS to mobile
 * viewports (i.e. phones, not tablets).
 *
 * Usage:
 * @include mobile-viewport() {
 *   :host {
 *     background-color: blue;
 *   }
 * }
 */
/**
 * Convert a font size to a dynamic font size.
 * Fonts that participate in Dynamic Type should use
 * dynamic font sizes.
 * @param size - The initial font size including the unit (i.e. px or pt)
 * @param unit (optional) - The unit to convert to. Use this if you want to
 * convert to a unit other than $baselineUnit.
 */
/**
 * Convert a font size to a dynamic font size but impose
 * a maximum font size.
 * @param size - The initial font size including the unit (i.e. px or pt)
 * @param maxScale - The maximum scale of the font (i.e. 2.5 for a maximum 250% scale).
 * @param unit (optional) - The unit to convert the initial font size to. Use this if you want to
 * convert to a unit other than $baselineUnit.
 */
/**
 * Convert a font size to a dynamic font size but impose
 * a minimum font size.
 * @param size - The initial font size including the unit (i.e. px or pt)
 * @param minScale - The minimum scale of the font (i.e. 0.8 for a minimum 80% scale).
 * @param unit (optional) - The unit to convert the initial font size to. Use this if you want to
 * convert to a unit other than $baselineUnit.
 */
/**
 * Convert a font size to a dynamic font size but impose
 * maximum and minimum font sizes.
 * @param size - The initial font size including the unit (i.e. px or pt)
 * @param minScale - The minimum scale of the font (i.e. 0.8 for a minimum 80% scale).
 * @param maxScale - The maximum scale of the font (i.e. 2.5 for a maximum 250% scale).
 * @param unit (optional) - The unit to convert the initial font size to. Use this if you want to
 * convert to a unit other than $baselineUnit.
 */
/**
 * A heuristic that applies CSS to tablet
 * viewports.
 *
 * Usage:
 * @include tablet-viewport() {
 *   :host {
 *     background-color: green;
 *   }
 * }
 */
/**
 * A heuristic that applies CSS to mobile
 * viewports (i.e. phones, not tablets).
 *
 * Usage:
 * @include mobile-viewport() {
 *   :host {
 *     background-color: blue;
 *   }
 * }
 */
/**
 * A heuristic that applies CSS to tablet
 * viewports.
 *
 * Usage:
 * @include tablet-viewport() {
 *   :host {
 *     background-color: green;
 *   }
 * }
 */
/**
 * A heuristic that applies CSS to mobile
 * viewports (i.e. phones, not tablets).
 *
 * Usage:
 * @include mobile-viewport() {
 *   :host {
 *     background-color: blue;
 *   }
 * }
 */
:host {
  /**
   * @prop --ion-grid-columns: The number of total Columns in the Grid
   * @prop --ion-grid-column-padding: Padding for the Column
   * @prop --ion-grid-column-padding-xs: Padding for the Column on xs screens and up
   * @prop --ion-grid-column-padding-sm: Padding for the Column on sm screens and up
   * @prop --ion-grid-column-padding-md: Padding for the Column on md screens and up
   * @prop --ion-grid-column-padding-lg: Padding for the Column on lg screens and up
   * @prop --ion-grid-column-padding-xl: Padding for the Column on xl screens and up
   */
  -webkit-padding-start: var(--ion-grid-column-padding-xs, var(--ion-grid-column-padding, 5px));
  padding-inline-start: var(--ion-grid-column-padding-xs, var(--ion-grid-column-padding, 5px));
  -webkit-padding-end: var(--ion-grid-column-padding-xs, var(--ion-grid-column-padding, 5px));
  padding-inline-end: var(--ion-grid-column-padding-xs, var(--ion-grid-column-padding, 5px));
  padding-top: var(--ion-grid-column-padding-xs, var(--ion-grid-column-padding, 5px));
  padding-bottom: var(--ion-grid-column-padding-xs, var(--ion-grid-column-padding, 5px));
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
  box-sizing: border-box;
  position: relative;
  flex-basis: 0;
  flex-grow: 1;
  width: 100%;
  max-width: 100%;
  min-height: 1px;
}
@media (min-width: 576px) {
  :host {
    -webkit-padding-start: var(--ion-grid-column-padding-sm, var(--ion-grid-column-padding, 5px));
    padding-inline-start: var(--ion-grid-column-padding-sm, var(--ion-grid-column-padding, 5px));
    -webkit-padding-end: var(--ion-grid-column-padding-sm, var(--ion-grid-column-padding, 5px));
    padding-inline-end: var(--ion-grid-column-padding-sm, var(--ion-grid-column-padding, 5px));
    padding-top: var(--ion-grid-column-padding-sm, var(--ion-grid-column-padding, 5px));
    padding-bottom: var(--ion-grid-column-padding-sm, var(--ion-grid-column-padding, 5px));
  }
}
@media (min-width: 768px) {
  :host {
    -webkit-padding-start: var(--ion-grid-column-padding-md, var(--ion-grid-column-padding, 5px));
    padding-inline-start: var(--ion-grid-column-padding-md, var(--ion-grid-column-padding, 5px));
    -webkit-padding-end: var(--ion-grid-column-padding-md, var(--ion-grid-column-padding, 5px));
    padding-inline-end: var(--ion-grid-column-padding-md, var(--ion-grid-column-padding, 5px));
    padding-top: var(--ion-grid-column-padding-md, var(--ion-grid-column-padding, 5px));
    padding-bottom: var(--ion-grid-column-padding-md, var(--ion-grid-column-padding, 5px));
  }
}
@media (min-width: 992px) {
  :host {
    -webkit-padding-start: var(--ion-grid-column-padding-lg, var(--ion-grid-column-padding, 5px));
    padding-inline-start: var(--ion-grid-column-padding-lg, var(--ion-grid-column-padding, 5px));
    -webkit-padding-end: var(--ion-grid-column-padding-lg, var(--ion-grid-column-padding, 5px));
    padding-inline-end: var(--ion-grid-column-padding-lg, var(--ion-grid-column-padding, 5px));
    padding-top: var(--ion-grid-column-padding-lg, var(--ion-grid-column-padding, 5px));
    padding-bottom: var(--ion-grid-column-padding-lg, var(--ion-grid-column-padding, 5px));
  }
}
@media (min-width: 1200px) {
  :host {
    -webkit-padding-start: var(--ion-grid-column-padding-xl, var(--ion-grid-column-padding, 5px));
    padding-inline-start: var(--ion-grid-column-padding-xl, var(--ion-grid-column-padding, 5px));
    -webkit-padding-end: var(--ion-grid-column-padding-xl, var(--ion-grid-column-padding, 5px));
    padding-inline-end: var(--ion-grid-column-padding-xl, var(--ion-grid-column-padding, 5px));
    padding-top: var(--ion-grid-column-padding-xl, var(--ion-grid-column-padding, 5px));
    padding-bottom: var(--ion-grid-column-padding-xl, var(--ion-grid-column-padding, 5px));
  }
}